var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    className: "wd-accent-touchpoints wd-accent",
    focusable: "false",
    role: "presentation",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    className: "wd-icon-container"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#005DBA",
    fillRule: "nonzero",
    d: "M21 20.248a8.525 8.525 0 0 1-2.845-2.092l-4.091 3.274a5.5 5.5 0 1 1-1.408-1.435l4.35-3.48A8.5 8.5 0 1 1 33 12.555l3.16.395a7.5 7.5 0 1 1-.147 1.997l-3.26-.407A8.519 8.519 0 0 1 28 20.248v.089a3.498 3.498 0 0 1 4.471 1.311 3.5 3.5 0 0 1 5.526 2.691A3.5 3.5 0 0 1 43 27.502l-.01 10.57C42.726 45.261 36.75 51 29.5 51a13.47 13.47 0 0 1-10.43-4.928l-.12-.162C15.732 41.081 14 37.554 14 35.5c0-4.302 3.21-9.855 7-12.461v-2.79zm7-2.27a6.5 6.5 0 1 0-7 0V12.5a3.5 3.5 0 1 1 7 0v5.478zM9.5 28a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm34-8a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM38 26.555V28c0 1.333-2 1.333-2 0v-3c0-.07.006-.137.016-.2l-.017-.37a1.5 1.5 0 0 0-2.367-1.154l-.632.451V26c0 1.333-2 1.333-2 0v-2.932l-.225-.36a1.498 1.498 0 0 0-1.917-.564L28 22.55V25a1 1 0 0 1-2 0V12.5a1.5 1.5 0 1 0-3 0V32a1 1 0 0 1-2 0v-6.411c-2.709 2.448-5 6.645-5 9.911 0 1.456 1.533 4.677 4.614 9.301A11.47 11.47 0 0 0 29.5 49c6.193 0 11.268-4.904 11.491-11.002L41 27.5a1.5 1.5 0 0 0-2.139-1.357l-.861.412z",
    className: "color-500"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.5 28a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7zm34-8a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zM21 17.978a6.5 6.5 0 1 1 7 0V12.5a3.5 3.5 0 1 0-7 0v5.478zm17 8.577l.861-.412A1.5 1.5 0 0 1 41 27.5l-.009 10.498C40.768 44.096 35.693 49 29.5 49a11.47 11.47 0 0 1-8.886-4.199C17.533 40.177 16 36.956 16 35.5c0-3.266 2.291-7.463 5-9.911V32a1 1 0 0 0 2 0V12.5a1.5 1.5 0 1 1 3 0V25a1 1 0 0 0 2 0v-2.45l.858-.406a1.498 1.498 0 0 1 1.917.565l.225.359V26c0 1.333 2 1.333 2 0v-2.273l.632-.45A1.5 1.5 0 0 1 36 24.43l.017.37c-.01.062-.016.129-.016.199v3c0 1.333 2 1.333 2 0v-1.445z",
    className: "french-vanilla-100"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.d6683d04814f914e321461d421e7f85e.svg";
export { ForwardRef as ReactComponent };